'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _omit2 = require('lodash/omit');
var _omit3 = _interopRequireDefault(_omit2);
var _mapValues2 = require('lodash/mapValues');
var _mapValues3 = _interopRequireDefault(_mapValues2);
var _isEmpty2 = require('lodash/isEmpty');
var _isEmpty3 = _interopRequireDefault(_isEmpty2);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports.default = finalQuestionForm;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _recompose = require('recompose');
var _reactFinalForm = require('react-final-form');
var _finalForm = require('final-form');
var _reduxQuestionField = require('./reduxQuestionField');
var _reduxQuestionField2 = _interopRequireDefault(_reduxQuestionField);
var _withCalculatedQuestions = require('./withCalculatedQuestions');
var _withCalculatedQuestions2 = _interopRequireDefault(_withCalculatedQuestions);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function getErrorMessages(props) {
  var submitFailed = props.submitFailed,
    _props$error = props.error,
    formValidationError = _props$error === undefined ? [] : _props$error,
    _props$submitError = props.submitError,
    formSubmitError = _props$submitError === undefined ? [] : _props$submitError,
    fieldValidationErrors = props.errors,
    submitErrors = props.submitErrors;
  if (!submitFailed) {
    return [];
  }
  var fieldSubmissionErrors = (0, _omit3.default)(submitErrors, _finalForm.FORM_ERROR);
  var formErrors = formValidationError.concat(formSubmitError);
  var hasFieldValidationErrors = !(0, _isEmpty3.default)(fieldValidationErrors);
  var hasFieldSubmissionErrors = !(0, _isEmpty3.default)(fieldSubmissionErrors);
  if (hasFieldValidationErrors || hasFieldSubmissionErrors) {
    return formErrors.concat([props.fieldErrorText]);
  }
  return formErrors || [];
}
var propTypes = {
  componentMapping: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired).isRequired,
  questions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    slug: _propTypes2.default.string.isRequired,
    default: _propTypes2.default.string,
    format: _propTypes2.default.func,
    isRequired: _propTypes2.default.bool,
    normalize: _propTypes2.default.func,
    validate: _propTypes2.default.func
  })).isRequired,
  requiredText: _propTypes2.default.string.isRequired,
  fieldErrorText: _propTypes2.default.string.isRequired
};
function finalQuestionForm(BaseComponent) {
  return (0, _recompose.compose)((0, _recompose.withProps)(function (props) {
    var defaults = props.questions.filter(function (question) {
      return 'default' in question;
    }).reduce(function (accum, question) {
      return _extends({}, accum, _defineProperty({}, question.slug, question.default));
    }, {});
    var initialValues = _extends({}, defaults, props.initialValues);
    return {
      initialValues: initialValues,
      componentMapping: (0, _mapValues3.default)(props.componentMapping, function (Component) {
        return (0, _reduxQuestionField2.default)(props.questions, props.requiredText)(Component);
      })
    };
  }), function (Component) {
    return function (formProps) {
      return _react2.default.createElement(_reactFinalForm.Form, _extends({
        render: function render(props) {
          return _react2.default.createElement(Component, _extends({
            errorMessages: getErrorMessages(props)
          }, props));
        }
      }, formProps));
    };
  }, _withCalculatedQuestions2.default)(BaseComponent);
}
finalQuestionForm.propTypes = propTypes;